import { CommonModule } from '@angular/common';
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { ConstantsService } from '@app/common/constants.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  imports:[CommonModule]
})
export class SliderComponent implements OnInit {
  @Input() public sliderData: any;
  @Input() public sliderHeader: any;
  @Input() public sliderDescription: any;
  @Input() public sliderTemplate: any;
  @Input() sliderId: string = "appSlider";
  @Output() closeSliderFunc = new EventEmitter();
  @Output() editMode: boolean;
  private readonly messageSource = new BehaviorSubject('');
  currentMessage = this.messageSource.asObservable();
  @Input() public keepSliderOpen:boolean = false;

  constructor(private readonly constantsService: ConstantsService) { }

  closeNav(_event) {
    this.editMode = false;
    this.closeSliderFunc.emit();
    this.messageSource.next('Closed!');
    if (!this.keepSliderOpen) {
      document.getElementById(this.sliderId).style.width = this.constantsService.sliderResetWidth;
    }
  }
  openNav(){
    this.editMode = true;
    document.getElementById(this.sliderId).style.width = this.constantsService.sliderWidth;
  }
  ngOnInit() {
    // This is intentional
  }
}
